import { Text, View, Pressable } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import Unicon from '@/components/General/Unicon';
import { useRouter } from 'expo-router';

const TrainingModuleCard = ({ module }) => {
    const router = useRouter();

    const statusColor = module.status === "ACTIVE" ? "success"
        : module.status === "DRAFT" ? "warning"
        : "textSecondary";

    return (
        <Pressable testID={`TrainingModuleCard-${module.id}`} onPress={() => router.push("/training/" + module.id)} style={styles.card}>
            <View style={styles.header}>
                <View style={styles.headerLeft}>
                    <View style={styles.iconCircle}>
                        <Unicon name="school-outline" size={20} colorVariant="primary" />
                    </View>
                    <View style={styles.headerText}>
                        <Text style={styles.name} numberOfLines={1}>{module.name}</Text>
                        {module.description && <Text style={styles.description} numberOfLines={2}>{module.description}</Text>}
                    </View>
                </View>
                <View style={styles.statusBadge(statusColor)}>
                    <Text style={styles.statusText(statusColor)}>{module.status}</Text>
                </View>
            </View>

            <View style={styles.footer}>

                <View style={styles.statsRow}>
                    <View style={styles.stat}>
                        <Unicon name="layers-outline" size={14} colorVariant="textSecondary" />
                        <Text style={styles.statText}>{module.classCount || 0} classes</Text>
                    </View>
                    <View style={styles.stat}>
                        <Unicon name="people-outline" size={14} colorVariant="textSecondary" />
                        <Text style={styles.statText}>{module.enrollmentCount || 0} enrolled</Text>
                    </View>
                    {(module.completedCount > 0) && (
                        <View style={styles.stat}>
                            <Unicon name="checkmark-circle-outline" size={14} colorVariant="success" />
                            <Text style={styles.statTextSuccess}>{module.completedCount} completed</Text>
                        </View>
                    )}
                </View>
            </View>
        </Pressable>
    );
};

const styles = StyleSheet.create(({ colors, fonts, spacing, typography }) => ({
    card: {
        backgroundColor: colors.surface,
        borderRadius: 12,
        padding: spacing.md,
        marginBottom: spacing.sm,
        _web: {
            transition: "all 0.15s ease",
            _hover: { backgroundColor: colors.hover }
        }
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: spacing.sm,
    },
    headerLeft: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        flex: 1,
        gap: spacing.sm,
    },
    iconCircle: {
        width: 36,
        height: 36,
        borderRadius: 10,
        backgroundColor: colors.primaryContainer,
        alignItems: 'center',
        justifyContent: 'center',
    },
    headerText: {
        flex: 1,
    },
    name: {
        fontSize: typography.body,
        fontFamily: fonts.heading,
        color: colors.text,
    },
    description: {
        fontSize: typography.caption,
        color: colors.textSecondary,
        marginTop: 2,
    },
    statusBadge: (statusColor) => ({
        paddingVertical: 2,
        paddingHorizontal: 8,
        borderRadius: 6,
        borderWidth: 1,
        borderColor: colors[statusColor],
        backgroundColor: colors[statusColor + 'Container'] || colors.surfaceVariant,
    }),
    statusText: (statusColor) => ({
        fontSize: 11,
        fontFamily: fonts.bold,
        color: colors[statusColor],
    }),
    footer: {
        gap: spacing.sm,
    },
    teacherRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: spacing.xs,
    },
    teacherName: {
        fontSize: typography.caption,
        color: colors.textSecondary,
        fontFamily: fonts.medium,
    },
    statsRow: {
        flexDirection: 'row',
        gap: spacing.md,
    },
    stat: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
    },
    statText: {
        fontSize: 12,
        color: colors.textSecondary,
    },
    statTextSuccess: {
        fontSize: 12,
        color: colors.success,
        fontFamily: fonts.bold,
    },
}));

export default TrainingModuleCard;
